import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';

const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem('USER_TOKEN');
	if (!token || token === 'undefined' || token === 'null' || token === '') {
		localStorage.removeItem('USER_TOKEN');
		return <Navigate to='/' replace />;
	}
	return children;
};

ProtectedRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}

			<Route path='*' element={<ProtectedRoute> <PAGE_404 /> </ProtectedRoute>} />

		</Routes>
	);
};

export default ContentRoutes;
